import GenericModal from 'components/GenericModal'
import { useTranslate } from 'lib/tolgee'
import { translations as translationsCommon } from 'modules/dashboard/common/dashboard.i18n'

import { translations } from './delete-dashboard-folder-modal.i18n'
import type { TDeleteDashboardFolderModalViewProps } from './delete-dashboard-folder-modal.types'
import './delete-dashboard-folder-modal.styles.scss'

export const DeleteDashboardFolderModalView = ({
  closeModal,
  handleDelete,
  isOpen,
  loading,
}: TDeleteDashboardFolderModalViewProps) => {
  const t = useTranslate()

  return (
    <GenericModal
      isOpen={isOpen}
      closeModal={closeModal}
      onClick={handleDelete}
      mainText={t(translationsCommon.deleteDashboardFolder)}
      subtitle={t(translations.actionDescription)}
      loading={loading}
    />
  )
}
